import { useEffect, useRef } from 'react'
import { API_GATEWAY_URL, CLOCK_WIDGET_URL } from '../../config'
import { gatewayApi } from '../../services/apiService'

// The widget's code lives in attendance-service (client/widget) and is loaded at
// runtime, so fixes deployed there show up here without a rebuild.
const ClockWidgetMount = () => {
  const ref = useRef(null)

  useEffect(() => {
    if (!CLOCK_WIDGET_URL || document.querySelector('script[data-clock-widget]')) return
    const script = document.createElement('script')
    script.src = CLOCK_WIDGET_URL
    script.async = true
    script.dataset.clockWidget = ''
    document.head.appendChild(script)
  }, [])

  useEffect(() => {
    // Any call through gatewayApi runs the shared 401 → refresh flow.
    if (ref.current) ref.current.refreshToken = () => gatewayApi.get('/attendance-service/clock/current')
  }, [])

  if (!CLOCK_WIDGET_URL) return null

  // bottom-left: the bottom-right corner belongs to SupportFab
  return <anyemp-clock-widget ref={ref} gateway-url={API_GATEWAY_URL} position="bottom-left" />
}

export default ClockWidgetMount
